import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'
import Layout from '@/components/Layout.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/home',
    name: 'home',
    component: HomeView
  },
  {
    path: "/admin",
    name: "admin",
    meta: { title: "首页", requiresAuth: true },
    redirect: "/admin",
    component: Layout,
    children:[
      {
        path: '/merchant',
        name: 'merchant',
        component: function () {
          return import('../views/merchant/IndexView.vue')
        },
        meta: { title: '商户列表' }
      },
      {
        path: '/insert_merchant',
        name: 'insert_merchant',
        component: function () {
          return import('../views/merchant/InsertView.vue')
        },
        meta: { title: '新增商户' }
      },
      {
        path: '/merchant_detail',
        name: 'merchant_detail',
        component: function () {
          return import('../views/merchant/DetailView.vue')
        },
        meta: { title: '新增详情' }
      },
      {
        path: '/users',
        name: 'users',
        component: function () {
          return import('../views/set/AccountManagement.vue')
        },
        meta: { title: '账号管理' }
      },
      {
        path: '/insert_users',
        name: 'insert_users',
        component: function () {
          return import('../views/set/InsertAccount.vue')
        },
        meta: { title: '新增账号' }
      },
      {
        path: '/roles',
        name: 'roles',
        component: function () {
          return import('../views/set/RolesView.vue')
        },
        meta: { title: '角色列表' }
      },
      {
        path: '/insert_roles',
        name: 'insert_roles',
        component: function () {
          return import('../views/set/InsertRoles.vue')
        },
        meta: { title: '新增角色' }
      },
      {
        path: '/logs',
        name: 'logs',
        component: function () {
          return import('../views/set/OperationLog.vue')
        },
        meta: { title: '操作日志' }
      },
      {
        path: '/explosive_local',
        name: 'explosive_local',
        component: function () {
          return import('../views/goods/explosive/explosiveLocal.vue')
        },
        meta: { title: '海斛商品' }
      },
      {
        path: '/points_list',
        name: 'points_list',
        component: function () {
          return import('../views/goods/explosive/points_list.vue')
        },
        meta: { title: '海金商品' }
      },
      {
        path: '/products',
        name: 'products',
        component: function () {
          return import('../views/goods/explosive/productsView.vue')
        },
        meta: { title: '商品列表' }
      },
      {
        path: '/member',
        name: 'member',
        component: function () {
          return import('../views/member/manage/memberView.vue')
        },
        meta: { title: '会员列表' }
      },
      {
        path: '/vip_member',
        name: 'vip_member',
        component: function () {
          return import('../views/member/manage/Vipmember.vue')
        },
        meta: { title: '会员列表' }
      },
      {
        path: '/member_detail',
        name: 'member_detail',
        component: function () {
          return import('../views/member/manage/detailView.vue')
        },
        meta: { title: '会员详情' }
      },
      {
        path: '/exp_order',
        name: 'exp_order',
        component: function () {
          return import('../views/order/goods/exp_order.vue')
        },
        meta: { title: '订单列表' }
      },
      {
        path: '/cash_order',
        name: 'cash_order',
        component: function () {
          return import('../views/order/goods/cash_order.vue')
        },
        meta: { title: '普通商品订单' }
      },
      {
        path: '/point_order',
        name: 'point_order',
        component: function () {
          return import('../views/order/goods/point_order.vue')
        },
        meta: { title: '海金订单' }
      },
      {
        path: '/vip_order',
        name: 'vip_order',
        component: function () {
          return import('../views/order/member//vip_order.vue')
        },
        meta: { title: '购卡订单' }
      },
      {
        path: '/recharge_order',
        name: 'recharge_order',
        component: function () {
          return import('../views/order/member//recharge_order.vue')
        },
        meta: { title: '充值订单' }
      },
      {
        path: '/message_config',
        name: 'message_config',
        component: function () {
          return import('../views/message/notice/merchant_message_config.vue')
        },
        meta: { title: '消息管理' }
      },
      {
        path: '/message_center',
        name: 'message_center',
        component: function () {
          return import('../views/message/center/list.vue')
        },
        meta: { title: '消息中心' }
      },
      {
        path: '/financial_cash',
        name: 'financial_cash',
        component: function () {
          return import('../views/finance/financial_cash.vue')
        },
        meta: { title: '现金账户' }
      },
    ]
  },
  {
    path: '/about',
    name: 'about',
    component: function () {
      return import('../views/AboutView.vue')
    }
  },
  {
    path: '/',
    name: 'login',
    component: function () {
      return import('../views/LoginView.vue')
    },
    meta: { title: '登录' }
  },
  
]

const router = new VueRouter({
  mode: 'hash',
  routes
})

router.beforeEach((to, from, next) => {
  // beforeEach是router的钩子函数，在进入路由前执行
  if (to.meta.title) {
    // 设置标题
    document.title = to.meta.title;
  }
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (!localStorage.getItem('token_item')) {
      router.push({ path: "/", replace: true });
    }
    next();
  }else{
    next();
  }
});

export default router
